/**
 * Product Gallery — thumbnail click to swap main image, chevron nav to scroll thumbnails.
 * Hides nav buttons when all thumbnails fit without scrolling.
 */
(function () {
  /* Hide nav buttons if 3 or fewer thumbnails (they all fit) */
  var gallery = document.querySelector('[data-product-gallery]');
  if (gallery) {
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    if (thumbs.length <= 3) {
      var prevBtn = gallery.querySelector('.product__gallery-prev');
      var nextBtn = gallery.querySelector('.product__gallery-next');
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
    }
  }

  /* Event delegation for clicks */
  document.addEventListener('click', function (e) {
    /* Thumbnail click → swap main image */
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (thumb) {
      var g = thumb.closest('[data-product-gallery]');
      if (!g) return;
      var mainImg = g.querySelector('[data-gallery-main]');
      if (!mainImg) return;

      var url = thumb.getAttribute('data-image-url');
      var alt = thumb.getAttribute('data-image-alt');
      if (url) {
        mainImg.src = url;
        mainImg.alt = alt || '';
      }
      g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.classList.remove('product__gallery-thumb--active');
      });
      thumb.classList.add('product__gallery-thumb--active');
      return;
    }

    /* Chevron prev/next → scroll thumbnails */
    var prev = e.target.closest('.product__gallery-prev');
    var next = e.target.closest('.product__gallery-next');
    var btn = prev || next;
    if (!btn) return;

    var g = btn.closest('[data-product-gallery]');
    if (!g) return;
    var ct = g.querySelector('[data-gallery-thumbs]');
    if (!ct) return;

    var scrollAmount = 110; /* thumb 100 + gap 10 */
    ct.scrollLeft += prev ? -scrollAmount : scrollAmount;
  });
})();
